import logoPrincipal from '@assets/atemporal/logoAtemporalCli.svg'
// TEMPORAL (solicitud del usuario): menú de usuario oculto — restaurar imports al reactivar
// import usuarioIcono from '@assets/nuevos-iconos/usuario.png'
// import PopupMenu from '@components/Topbar/popUp'
// import { useUser } from '@context/user'
import { useTopbarPrecioTotal } from '@hooks/useTopbarPrecioTotal'
import { createRootUrl } from '@proxies/index'
import { useAppStore } from '@store'
import { ui } from '@utils/i18n/uiCopy'
// import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Topbar compacta para tablet/móvil (48px): logo + precio total.
 * TEMPORAL: menú de usuario oculto (misma estrategia que desktop).
 */
export function CompactTopbar() {
  const navigate = useNavigate()
  // TEMPORAL (solicitud del usuario): menú de usuario oculto
  // const { user } = useUser()
  const isModalOpen = useAppStore((s) => s.isModalOpen)
  const prefs = useAppStore.use.prefs()
  const { precioTotalValue, precioTotalFormatted } = useTopbarPrecioTotal()
  // Misma resolución de logo que Desktop Topbar.
  const apiUrl = createRootUrl()
  const isAtemporalApi = apiUrl.includes('pf032api.for2home.com')
  const logoToUse = isAtemporalApi ? logoPrincipal : prefs?.ICONOCLIPRINCIPAL || logoPrincipal
  // const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  // const [localName] = useState(() => {
  //   try {
  //     const stored = localStorage.getItem('userData')
  //     if (stored) {
  //       const parsed = JSON.parse(stored) as { name?: string; nombre?: string }
  //       return parsed.name || parsed.nombre || 'Usuario'
  //     }
  //   } catch {
  //     /* ignore */
  //   }
  //   const u = user as { name?: string; nombre?: string } | null | undefined
  //   return u?.name || u?.nombre || 'Usuario'
  // })

  return (
    <header className='relative z-[60] flex h-12 w-full shrink-0 items-center justify-between gap-2 bg-white/90 px-3 backdrop-blur-sm'>
      <button
        type='button'
        disabled={isModalOpen}
        onClick={() => !isModalOpen && navigate('/planner')}
        className='flex h-10 min-w-0 shrink items-center'
        aria-label='Inicio'
      >
        <img
          src={logoToUse}
          alt='Logo'
          className='h-8 w-auto max-w-[140px] object-contain'
        />
      </button>

      {precioTotalValue > 0 ? (
        <div
          className='flex shrink-0 cursor-default items-center text-sm font-semibold text-C/Color3'
          aria-live='polite'
        >
          <span className='mr-1.5'>{ui('total')}</span>
          <span>{precioTotalFormatted} €</span>
        </div>
      ) : null}

      {/* TEMPORAL (solicitud del usuario): menú de usuario oculto en mobile/tablet.
          Restaurar este botón + PopupMenu cuando se reactive. */}
      {/*
      <button
        type='button'
        onClick={() => setIsUserMenuOpen((v) => !v)}
        className='flex h-10 items-center gap-2 rounded-full pl-1 pr-2'
        aria-label='Menú de usuario'
        aria-expanded={isUserMenuOpen}
      >
        <img src={usuarioIcono} alt='' className='h-8 w-8 rounded-full object-cover' />
        <span className='hidden max-w-[100px] truncate text-sm font-medium text-C/Color3 min-[480px]:inline'>
          {localName}
        </span>
      </button>

      {isUserMenuOpen && (
        <div className='absolute right-2 top-12 z-[70]'>
          <PopupMenu
            isOpen={isUserMenuOpen}
            onClose={() => setIsUserMenuOpen(false)}
          />
        </div>
      )}
      */}
    </header>
  )
}
